import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private activeRequests = 0;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable().pipe(
    distinctUntilChanged(),
    shareReplay(1)
  );

  show() {
    this.activeRequests++;
    setTimeout(() => {
      this.isLoadingSubject.next(true);
    }, 0);
  }

  hide() {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0) {
      setTimeout(() => {
        this.isLoadingSubject.next(false);
      }, 0);
    }
  }
}
